import CloseCircle from 'assets/icons/CloseCircle';
import COLOR from 'constants/color';
import { TIMEOUT_DELAY } from 'constants/general';
import { useEffect, useState } from 'react';
import { runAfterDelay } from 'utils/helpers';

interface BannerProps {
  message: string;
  contentWrapperStyles?: string;
  wrapperStyles?: string;
  defaultValue?: boolean;
  timeOut?: number;
  onClose?: () => void;
}

const Banner = ({
  message,
  wrapperStyles = 'self-center',
  contentWrapperStyles = 'w-fit p-4',
  defaultValue = true,
  timeOut = TIMEOUT_DELAY.BANNER,
  onClose
}: BannerProps) => {
  const [showBanner, setShowBanner] = useState(defaultValue);

  useEffect(() => {
    const timeoutId = runAfterDelay(() => {
      setShowBanner(false);
      onClose?.();
    }, timeOut);
    return () => clearTimeout(timeoutId);
  }, [timeOut, onClose]);

  return showBanner ? (
    <div className={`relative animate-fadeIn ${wrapperStyles}`}>
      <div
        className={`rounded shadow dark:bg-secondary-dark-200 dark:text-secondary-dark-900 text-black bg-primary-200 ${contentWrapperStyles}`}>
        <p className='text-xs md:text-sm text-center'>{message}</p>
      </div>
      <button
        aria-label='close-banner'
        onClick={() => {
          setShowBanner(false);
          onClose?.();
        }}
        className='absolute -top-1.5 -right-1.5 bg-white dark:bg-secondary-dark-400 rounded-full'>
        <CloseCircle
          styles='w-4 h-auto'
          fill={COLOR.SEMANTIC.ERROR}
          fillDarkMode={COLOR.SEMANTIC.ERROR}
        />
      </button>
    </div>
  ) : null;
};

export default Banner;
